import { defineComponent as C, computed as i, openBlock as a, createElementBlock as l, normalizeStyle as z, normalizeClass as t, toDisplayString as s, createCommentVNode as r, createBlock as d, withCtx as y, createVNode as _ } from "vue";
import x from "./index28.js";
import u from "./index60.js";
const P = ["aria-label", "aria-disabled", "tabindex", "disabled"], S = /* @__PURE__ */ C({
  __name: "BaseIconButton",
  props: {
    icon: {},
    label: { default: "" },
    labelPosition: { default: "left" },
    size: { default: "md" },
    shape: { default: "circle" },
    color: { default: "currentColor" },
    backgroundColor: {},
    padding: {},
    badge: {},
    disabled: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 }
  },
  emits: ["click"],
  setup(p, { emit: f }) {
    const e = p, m = f, c = (o) => {
      switch (o) {
        case "lg":
        case "md":
          return "md";
        case "sm":
          return "sm";
        default:
          return "md";
      }
    }, b = (o) => o?.color ? o.color : "currentColor", g = i(() => {
      const o = [
        "inline-flex items-center justify-center",
        "transition-all duration-200",
        "select-none",
        "focus:outline-none",
        "icon-button",
        `icon-button-shape-${e.shape}`,
        e.backgroundColor ? "icon-button-has-bg" : "icon-button-no-bg",
        `icon-button-size-${e.size}`
      ];
      return e.disabled && o.push("icon-button-disabled"), e.padding && o.push("icon-button-with-custom-padding"), e.label && o.push("icon-button-with-label"), e.label && (e.labelPosition === "top" || e.labelPosition === "bottom" ? o.push("flex-col") : o.push("flex-row"), e.labelPosition === "left" || e.labelPosition === "right" ? o.push("gap-1.5") : (e.labelPosition === "top" || e.labelPosition === "bottom") && o.push("gap-1")), o;
    }), n = i(() => ["icon-button-label", `icon-button-label-${e.size}`]), h = i(() => {
      const o = {};
      return e.color && e.color !== "currentColor" && (o.color = e.color), e.backgroundColor && (o.backgroundColor = e.backgroundColor), e.padding && (o.padding = e.padding), o;
    }), k = i(() => e.ariaLabel ? e.ariaLabel : e.label ? e.label : e.icon.name);
    function v(o) {
      e.disabled || m("click", o);
    }
    return (o, w) => (a(), l("button", {
      type: "button",
      class: t(g.value),
      style: z(h.value),
      "aria-label": k.value,
      "aria-disabled": e.disabled ? "true" : void 0,
      tabindex: e.disabled ? -1 : 0,
      disabled: e.disabled,
      onClick: v
    }, [
      e.label && e.labelPosition === "top" ? (a(), l("span", {
        key: 0,
        class: t(n.value)
      }, s(e.label), 3)) : r("", !0),
      e.label && e.labelPosition === "left" ? (a(), l("span", {
        key: 1,
        class: t(n.value)
      }, s(e.label), 3)) : r("", !0),
      e.badge && e.badge.show !== !1 ? (a(), d(x, {
        key: 2,
        value: e.badge.value ?? 0,
        max: e.badge.max,
        variant: e.badge.variant,
        color: e.badge.color,
        "show-zero": e.badge.showZero,
        hidden: e.badge.hidden,
        overlap: e.badge.overlap,
        "anchor-origin": e.badge.anchorOrigin
      }, {
        default: y(() => [
          _(u, {
            name: e.icon.name,
            size: c(e.size),
            color: b(e.icon)
          }, null, 8, ["name", "size", "color"])
        ]),
        _: 1
      }, 8, ["value", "max", "variant", "color", "show-zero", "hidden", "overlap", "anchor-origin"])) : (a(), d(u, {
        key: 3,
        name: e.icon.name,
        size: c(e.size),
        color: b(e.icon)
      }, null, 8, ["name", "size", "color"])),
      e.label && e.labelPosition === "right" ? (a(), l("span", {
        key: 4,
        class: t(n.value)
      }, s(e.label), 3)) : r("", !0),
      e.label && e.labelPosition === "bottom" ? (a(), l("span", {
        key: 5,
        class: t(n.value)
      }, s(e.label), 3)) : r("", !0)
    ], 14, P));
  }
});
export {
  S as default
};
